import { Component, Optional, Inject, Injector, ChangeDetectionStrategy } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, NG_ASYNC_VALIDATORS } from '@angular/forms';

import { InputBase } from '../../../base/input-base';


@Component({
    selector: 'aa-input-date2',
    templateUrl: './input-date2.component.html',
    styleUrls: [
        '../input.component.scss'
    ],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: InputDate2Component,
            multi: true,
        }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InputDate2Component extends InputBase<string>
{
    private static identifier = 0;

    constructor (
        injector: Injector,
        @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
        @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>
    )
    {
        super(injector);
        this.fieldId = `input-date-${InputDate2Component.identifier++}-id`;
    }
}
